/*eslint-disable array-callback-return  */
import React from 'react';
import PropTypes from 'prop-types';

import FormatGraphDataService from 'components/year-review/services/FormatGraphDataService';

const YRTable = ({
    name, data, style,
}) => {
    const {
        unit,
    } = style;

    return (
        <div className="yr-table-container is-fixed-height">
            <table className="yr-table">
                <thead>
                    <tr>
                        <th />
                        <th>{name}</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((item) => {
                        const itemName = item.name;
                        let itemValue = item.values;

                        if (typeof item.name === 'undefined' || typeof item.values === 'undefined') {
                            return;
                        }

                        if (typeof itemValue === 'object') {
                            return Object.values(itemValue).map((nestedItem) => {
                                const nestedName = nestedItem.name;
                                const nestedValue = nestedItem.values;

                                if (typeof nestedValue === 'object') {
                                    return false;
                                }

                                return (
                                    <tr key={`${nestedName}-${nestedValue}`}>
                                        <td>{nestedName} <b>{itemName}</b></td>
                                        <td>
                                            {nestedValue}
                                            {unit}
                                        </td>
                                    </tr>
                                );
                            });
                        }

                        return (
                            <tr key={`${itemName}-${itemValue}`}>
                                <td>{itemName}</td>
                                {itemValue && (
                                    <td>
                                        {FormatGraphDataService.addCommas(itemValue)}
                                        {unit}
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

YRTable.defaultProps = {
    style: {},
};

YRTable.propTypes = {
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.any).isRequired,
    style: PropTypes.objectOf(PropTypes.any),
};

export default YRTable;
